import valueProc from "./valueProc";

const isRuleGroup = (ruleOrGroup) => {
    return !!(ruleOrGroup.combinator && ruleOrGroup.rules);
};

const parseQuery = (ruleGroup) => {

    const processRule = (rule) => {
        let operator = rule.operator || "=";
        const value = valueProc(rule.field, operator, rule.value);

        switch(operator.toLowerCase()) {
            case 'null':
                operator = 'is null';
                break;
            case 'notnull':
                operator = 'not isnull';
                break;
            case 'notin':
                operator = 'not in';
                break;
            case 'contains':
            case 'beginswith':
            case 'endswith':
                operator = 'like';
                break;
            case 'doesnotcontain':
            case 'doesnotbeginwith':
            case 'doesnotendwith':
                operator = 'not like';
                break;
            default:
                break;
        }

        const filter = {field: rule.field, operator};
        if (value) {
            filter.value = value;
        }
        return filter;
    };

    const processRuleGroup = (rg) => {
        const processedRules = rg.rules.map((rule) => {
            if (isRuleGroup(rule)) {
                return processRuleGroup(rule);
            }
            return processRule(rule);
        });
        return {filters: processedRules, operator: rg.not ? 'NOT ' + rg.combinator : rg.combinator};
    };

    return processRuleGroup(ruleGroup);
}

export default parseQuery;